export default __webpack_public_path__ + "vendor/scripts/ng-table.min.js";